import { render, staticRenderFns } from "./AdminCatalog.vue?vue&type=template&id=67c0f938&scoped=true"
import script from "./AdminCatalog.vue?vue&type=script&lang=js"
export * from "./AdminCatalog.vue?vue&type=script&lang=js"
import style0 from "./AdminCatalog.vue?vue&type=style&index=0&id=67c0f938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0f938",
  null
  
)

export default component.exports